import {
  defaultDataLayerName,
  GTM_INIT_SELECTOR,
  GTM_SCRIPT_SELECTOR,
  type GTMParams,
  getTags,
} from "@frontend/roz-sdk-core";
import { useEffect } from "react";

export function GoogleTagManager(properties: GTMParams) {
  const {
    gtmId,
    gtmScriptUrl = "https://www.googletagmanager.com/gtm.js",
    dataLayerName = defaultDataLayerName,
    auth,
    preview,
    dataLayer,
  } = properties;

  const gtmLayer =
    dataLayerName === defaultDataLayerName ? "" : `&l=${dataLayerName}`;
  const gtmAuth = auth ? `&gtm_auth=${auth}` : "";
  const gtmPreview = preview ? `&gtm_preview=${preview}&gtm_cookies_win=x` : "";

  // Маунт-once: пропсы с первого рендера. Смена gtmId/auth/preview игнорируется.
  // Дедуп при StrictMode / ремаунте / двух инстансах — через data-ntpc в DOM.
  // biome-ignore lint/correctness/useExhaustiveDependencies: инжект только на маунт
  useEffect(() => {
    const { getGTMScript, getGTMInitScript } = getTags({
      gtmId,
      gtmAuth,
      gtmPreview,
      gtmScriptUrl,
      gtmLayer,
      dataLayer,
      dataLayerName,
    });

    if (!document.head.querySelector(GTM_INIT_SELECTOR)) {
      document.head.append(getGTMInitScript());
    }

    const appendGtmScript = () => {
      if (document.head.querySelector(GTM_SCRIPT_SELECTOR)) {
        return;
      }
      document.head.append(getGTMScript());
    };

    if (document.readyState === "complete") {
      appendGtmScript();
      return;
    }

    window.addEventListener("load", appendGtmScript, { once: true });
    return () => {
      window.removeEventListener("load", appendGtmScript);
    };
  }, []);

  return null;
}
